import {Utils} from "./utils";

/**
 *
 * @param tabIdx
 */
export default {
    /**
     *
     * @param tabIdx
     */
    change: function(tabIdx) {
        let currentTab, currentIndex;
        const content = document.querySelectorAll('.tab-content');
        const parent = document.querySelector('.tabs-contents');
        const topParent = document.querySelector('.main-wrp');


        if (!parent || !content.length || !content[tabIdx])  {
            return
        }

        for (let i = 0, len = content.length; i < len; i++) {
            if (content[i].classList.contains('active')) {
                currentIndex = i;
                currentTab = content[i];
            }
        }

        if (currentIndex === +tabIdx) {
            return;
        }

        const absoluteClass = 'absoluteTab';
        const activeClass = 'active';
        const leftClass = currentIndex < tabIdx ? 'move-left' : 'move-right';
        const rightClass = currentIndex > tabIdx ? 'move-left' : 'move-right';
        const newTab = content[tabIdx];


        if (currentTab) {
            topParent.style.overflow = 'hidden';
            currentTab.classList.add(absoluteClass);
            newTab.classList.add(absoluteClass);
            newTab.classList.add(activeClass);
            newTab.classList.add(rightClass);

            setTimeout(() => {
                const height = newTab.classList.contains('video') ? 600 : newTab.offsetHeight;

                currentTab.classList.add(leftClass);
                newTab.classList.remove(rightClass);
                parent.style.minHeight = height + 'px';
            }, 30);

            setTimeout(() => {
                currentTab.classList.remove(activeClass);
                currentTab.classList.remove(leftClass);
                newTab.classList.remove(absoluteClass);
                topParent.style.overflow = '';

                if (global.bLazy) {
                    global.bLazy.revalidate();
                }

                this.afterTabChange(currentTab, newTab);
            }, 450);

            this.beforeTabChange(currentTab, newTab);

        } else {
            newTab.classList.add(activeClass);
        }

        if (global.bLazy) {
            global.bLazy.revalidate();
        }
    },

    /**
     *
     */
    init: function() {
        const tabName = location.hash.replace('#', '');
        let tabLabel = document.querySelectorAll(`[data-tab-name='${tabName}']`);
        let id = 0;

        if (tabLabel.length === 0) {
            tabLabel = [document.getElementById('itc-tab0')]
        }

        tabLabel.forEach(el => {
            if (el) {
                el.checked = 1;
                id = +el.id.replace(/\D+/, '');
            }
        });

        this.change(id);
    },

    /**
     *
     * @param tabIdx
     * @param tabCaption
     */
    open: function(tabIdx, tabCaption) {
        if (window.innerWidth > Utils.screen.sm) {
            this.change(tabIdx);
        } else {
            this.tabScrollChange(tabIdx);
        }
        location.hash = tabCaption.trim().replace(/\W+/g, '-').toLowerCase();
    },

    afterTabChange: (newTab) => {},
    beforeTabChange: (currentTab, newTab) => {},

    initStickyTabs: function(bottomSelector) {
        const parentEl = document.getElementById('tabs-content-box');

        if (!parentEl) {
            return
        }

        const menuEl = document.getElementById('tabs-header');
        const bottomEl = document.querySelector(bottomSelector);
        const menuItems = menuEl.querySelectorAll('.label-box');
        let mobTitles;
        let headerTop;
        let tabsHeader;
        let tabsContent;
        let contentBoundaries;
        let activeClass = 'active';

        window.addEventListener('resize', resize);

        function initSticky() {
            tabsHeader = document.querySelector('#tabs-header');
            tabsContent = document.querySelector('#tabs-content-box');

            if (!tabsHeader) {
                return
            }

            tabsHeader.classList.add('sticky');
            const top = parseInt(getComputedStyle(tabsHeader).top);

            tabsHeader.classList.remove('sticky');
            tabsContent.style.marginTop =  0;
            headerTop = position(tabsHeader).top - top;
        }

        let _handler;
        function resize() {
            if (_handler) {
                clearTimeout(_handler);
            }

            _handler = setTimeout(() => {
                document.removeEventListener('scroll', scrollDesktop);
                document.removeEventListener('scroll', scrollMobile);

                if (window.innerWidth > Utils.screen.sm) {
                    initSticky();
                    scroll();
                    document.addEventListener('scroll', scrollDesktop);
                } else {
                    initStickyMobile();
                    scrollMobile();
                    document.addEventListener('scroll', scrollMobile);
                    global.bLazy.revalidate();
                }
            }, 300);
        }

        setTimeout(resize, 500);
        this.afterTabChange = this.scrollToTabTopAfterTabChange.bind(this, bottomEl);

        function initStickyMobile() {
            const content = parentEl.querySelectorAll('.tab-content');
            let start = 0;
            let end = 0;

            mobTitles = parentEl.querySelectorAll('.section-title');
            contentBoundaries = [];

            content.forEach((itemEl, idx) => {
                const end = Utils.offset(itemEl).top - 140;

                contentBoundaries.push([start, end]);
                start = end;
            });
            end = Utils.offset(document.getElementById('bottom-content')).top - 80;
            contentBoundaries.push([start, end]);
            contentBoundaries.push([end, 1e10]);

            document.body.removeEventListener("click", closeStickyMobile);
            document.body.addEventListener("click", closeStickyMobile);
        }

        function closeStickyMobile() {
            document.getElementById('sticky-toggle').checked = false
        }

        function scrollDesktop() {
            const pos = scrollPos();

            if (!tabsHeader) {
                return
            }

            if (pos > headerTop) {
                tabsHeader.classList.add('sticky');
                tabsContent.style.marginTop = Utils.outerHeight(tabsHeader) + 'px';

                const bottomTop = Utils.offset(bottomEl).top - 100;
                const transform = pos > bottomTop ? 'translateY(-100px)' : 'translateY(0)';

                tabsHeader.style.transform = transform;
            } else {
                tabsHeader.classList.remove('sticky');
                tabsContent.style.marginTop = 0;
            }
        }

        let currentTab = 0;
        function scrollMobile() {
            const pos = scrollPos();

            contentBoundaries.forEach((bd, idx) => {
                if (pos > bd[0] && pos < bd[1]) {
                    if (currentTab !== idx) {
                        if (idx === 0 || idx === (contentBoundaries.length - 1)) {
                            menuItems.forEach(el => el.classList.remove(activeClass));
                            menuEl.classList.remove('sticky');
                        } else {
                            const oldIdx = currentTab - 1;
                            menuItems[idx - 1] && menuItems[idx - 1].classList.add(activeClass);

                            if ([0,1,2].indexOf(oldIdx) > -1) {
                                menuItems[oldIdx] && menuItems[oldIdx].classList.remove(activeClass);
                            }

                            menuEl.classList.add('sticky')
                        }
                        currentTab = idx;
                    }
                }
            })
        }
    },

    /**
     *
     * @param bottomEl
     */
    scrollToTabTopAfterTabChange: function(bottomEl) {
        setTimeout(() => {
            const bottomTop = Utils.offset(bottomEl).top - window.innerHeight;

            if (bottomTop < scrollPos()) {
                document.getElementById('scroll-tab-top').scrollIntoView({
                    block: "nearest",
                    behavior: "smooth"
                });
            }

        }, 400)
    },

    /**
     *
     * @param tabIdx
     */
    tabScrollChange: function(tabIdx) {
        const content = document.querySelectorAll('#tabs-content-box .tab-content');

        if (!content.length || !content[tabIdx])  {
            return
        }

        content[tabIdx].querySelector('.scroll-point').scrollIntoView({
            block: "start",
            behavior: "smooth"
        });
    }
};


const position = (el) => {
    const {top, left} = el.getBoundingClientRect();
    const {marginTop, marginLeft} = getComputedStyle(el);
    return {
        top: top - parseInt(marginTop, 10) + scrollPos(),
        left: left - parseInt(marginLeft, 10)
    };
}

const scrollPos = () => {
    return window.pageYOffset || document.documentElement.scrollTop;
}
